export const config = {
  title: "Hoffman",
  company_logo: "hoffman.png",
  logo_placements: [
    "Left Chest",
    "Right Sleeve",
    "Left Sleeve",
    "Yoke",
    "Front Center",
  ],
  show_image_preview: true,
  embroideries: {
    hat: [
      "Audi",
      "BMW",
      "Hoffman Collision",
      "Hoffman Driven By Trust",
      "Ford Lincoln",
      "Honda Blue",
      "Hoffman H",
      "Hoffman Insurance",
      "Lexus",
      "Hoffman Motorsports",
      "Nissan",
      "Porsche With Shield",
      "Toyota",
    ],
    mens: [
      "Audi",
      "BMW",
      "Hoffman Collision",
      "Hoffman Driven By Trust",
      "Ford Lincoln",
      "Honda Blue",
      "Hoffman H",
      "Hoffman Insurance",
      "Lexus",
      "Hoffman Motorsports",
      "Nissan",
      "Porsche With Shield",
      "Toyota",
    ],
    womens: [
      "Audi",
      "BMW",
      "Hoffman Collision",
      "Hoffman Driven By Trust",
      "Ford Lincoln",
      "Honda Blue",
      "Hoffman H",
      "Hoffman Insurance",
      "Lexus",
      "Hoffman Motorsports",
      "Nissan",
      "Porsche With Shield",
      "Toyota",
    ],
    accessory: [],
    customs: [],
    office: [],
    sales: [],
    service: [],
    detail: [],
    bodyshop: [],
    parts: [],
  },
  email_recipients: [
    "lbudbill@gpcorp.com",
    "lbudbell@comcast.net",
    "bsugden@gpcorp.com",
  ],

  stores: [
    {
      name: "Hoffman APA",
      address: "600 Connecticut Blvd, East Hartford, CT 06108",
      code: "HOFAPA",
    },
  ],
  bypass_codes: ["BRONX"],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [{ name: "", phone: "" }],
  route_prefix: "/hoffman",
  paypal_not_supported: true,
  password: "HoffmaN",
};
